let elements = {
  mainImage: {
    imagePath: 'games/page018_game0/img/bcg.png',
    pos: {
      y: 0,
      x: 0,
    },
  },
  // withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  noClose: true,
  images: [
    {
      pos: {
        y: 290,
        x: 1610,
      },
      audio: {
        src: 'games/page018_game0/audio/klik.mp3',
      },
      src: 'games/page018_game0/img/00.png',
      close: true,
      correct: true,
      width: 117 * 0.8,
      height: 102 * 0.8,
      images: [
        {
          pos: {
            y: 250,
            x: 1604,
          },
          src: 'games/page018_game0/img/statusCorrect.png',
          width: 100,
          height: 100,
        },
      ],
    },
    {
      pos: {
        y: 380,
        x: 615,
      },
      audio: {
        src: 'games/page018_game0/audio/klik.mp3',
      },
      src: 'games/page018_game0/img/01.png',
      close: true,
      correct: true,
      width: 64 * 0.8,
      height: 82 * 0.8,
      images: [
        {
          pos: {
            y: 310,
            x: 615,
          },
          src: 'games/page018_game0/img/statusCorrect.png',
          width: 100,
          height: 100,
        },
      ],
    },
    {
      pos: {
        y: 570,
        x: 1114,
      },
      src: 'games/page018_game0/img/02.png',
      close: true,
      width: 200 * 0.8,
      correct: true,
      height: 179 * 0.8,
      audio: {
        src: 'games/page018_game0/audio/klik.mp3',
      },
      images: [
        {
          pos: {
            y: 540,
            x: 1163,
          },
          src: 'games/page018_game0/img/statusCorrect.png',
          width: 100,
          height: 100,
        },
      ],
    },
    //
    {
      pos: {
        y: 443,
        x: 1466,
      },
      src: 'games/page018_game0/img/03.png',
      close: true,
      width: 295 * 0.8,
      correct: true,
      audio: {
        src: 'games/page018_game0/audio/klik.mp3',
      },
      height: 472 * 0.8,
      images: [
        {
          pos: {
            y: 513,
            x: 1546,
          },
          src: 'games/page018_game0/img/statusCorrect.png',
          width: 100,
          height: 100,
        },
      ],
    },
    {
      pos: {
        y: 725,
        x: 215,
      },
      audio: {
        src: 'games/page018_game0/audio/klik.mp3',
      },
      src: 'games/page018_game0/img/04.png',
      close: true,
      correct: true,
      width: 632 * 0.8,
      height: 427 * 0.8,
      images: [
        {
          pos: {
            y: 775,
            x: 405,
          },
          src: 'games/page018_game0/img/statusCorrect.png',
          width: 100,
          height: 100,
        },
      ],
    },
  ],
  // mbAudioItemData: [
  //   {
  //     src: 'audio/test/test.mp3',
  //     audioConfig: {
  //       autoplay: false,
  //       loop: false,
  //       volume: 1,
  //     },
  //     iconConfig: {
  //       fill: 'none',
  //     },
  //     pos: {
  //       y: 0,
  //       x: 0,
  //     },
  //   },
  // ],
};

export default elements;
